// Access Doors messaging is an explicit add-on. Never infer an offer
// from lockType: messaging hotels retain their dormant vendor configuration.
function getOfferCapabilities(hotel = {}) {
  const serviceType = hotel.serviceType || "access-doors";
  const accessDoors = serviceType === "access-doors";
  return {
    serviceType,
    accessDoors,
    messaging: serviceType === "messaging" || hotel.messagingEnabled === true,
    upsells:
      typeof hotel.upsellsEnabled === "boolean"
        ? hotel.upsellsEnabled
        : accessDoors,
    ai: hotel.aiEnabled === true,
    aiInsights: hotel.aiInsightsEnabled === true,
    staffAssistant: true,
  };
}
const LOCK_FIELDS = [
  "lockType",
  "sendMobileKeyQuietly",
  "useUpgradeModules",
  "disableBatteryCheck",
  "adminPin",
  "hasWifiGateway",
  "usePasscodes",
  "useRandomCode",
  "numberOfLastDigitsUsed",
  "partialSetup",
  "partialSetupStrict",
  "houseCleaningEnabled",
  "commonAreaFixedPasscode",
  "commonAreaFixedLabel",
  "sector",
  "autoSendEnabled",
  "autoSendWalkinTime",
  "autoSendValidNow",
  "useFallbackOfflineCodes",
  "sendKeysOnlyIfApproved",
  "onlyIfWRPAgreementCompletedWalkin",
  "postCheckinMessageEnabled",
  "checkKeyUsedByCron",
  "gracePeriod",
  "beforeGracePeriod",
];
const UPSELL_FIELDS = [
  "offerEarlyCheckin",
  "offerUpgrade",
  "offerLateCheckout",
];

function changedVisibleFields(values, initial, fields, hidden = []) {
  return Object.fromEntries(
    fields
      .filter(
        (key) =>
          !hidden.includes(key) &&
          values[key] !== undefined &&
          JSON.stringify(values[key]) !== JSON.stringify(initial[key]),
      )
      .map((key) => [key, values[key]]),
  );
}
function supportsOfflineFallback(hotel) {
  const resolved = hotel || {};
  return (
    getOfferCapabilities(resolved).accessDoors &&
    (resolved.capabilities?.fallbackOfflinePasscodes ??
      (resolved.lockType || "ttlock") === "ttlock")
  );
}
export {
  getOfferCapabilities,
  LOCK_FIELDS,
  UPSELL_FIELDS,
  changedVisibleFields,
  supportsOfflineFallback,
};
